@if (data(); as data) {
  <app-alerts />

  <app-public-subscription-form
    [data]="data"
    (cancelClickEvent)="handleCancelClickEvent()"
    (submitClickEvent)="handleSubmitClickEvent($event)" />
} @else {
  <app-spinner-filled />
}
